import React, { useState } from "react";
import { useNavigate } from "react-router";

const OrganizationAddTaskModal = ({ onLogin }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    taskName: "",
    taskDescription: "",
    skills: "",
    hoursNeeded: "",
    termsAccepted: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin();
    navigate("/organization");
    console.log(formData);
  };

  return (
    <div className="flex items-center justify-center h-full">
      <div className="relative w-full items-center flex justify-center flex-col p-8 bg-[#F6F2EF] shadow-md rounded-3xl border border-gray-200">

        <button className='absolute right-3 top-4 text-black' onClick={onLogin}>
          &#10006;
        </button>

        <form
          onSubmit={handleSubmit}
          className="w-full "
        >
          <h2 className="text-2xl font-bold mb-3">
            Create a New Task
          </h2>
          <div className="mb-3">
            <label className="block  mb-2">
              Task Name
            </label>
            <input
              type="text"
              name="taskName"
              value={formData.taskName}
              onChange={handleChange}
              placeholder="Value"
              className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
          </div>
          <div className="mb-3">
            <label className="block  mb-2">
              Task Description
            </label>
            <textarea
              name="taskDescription"
              value={formData.taskDescription}
              onChange={handleChange}
              placeholder="Value"
              className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            ></textarea>
          </div>
          <div className="mb-3">
            <label className="block  mb-2">
              Volunteer Requirements
            </label>
            <input
              type="text"
              name="skills"
              value={formData.skills}
              onChange={handleChange}
              placeholder="Skills"
              className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
          </div>
          <div className="mb-3">
            <input
              type="text"
              name="hoursNeeded"
              value={formData.hoursNeeded}
              onChange={handleChange}
              placeholder="Hours needed"
              className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
          </div>
          <div className=" text-sm flex items-center">
            <input
              type="checkbox"
              name="termsAccepted"
              checked={formData.termsAccepted}
              onChange={handleChange}
              className="mr-2 w-4 h-4 bg-transparent rounded border-2 border-green-500 text-green-500 focus:ring-0"
            />
            <label className=" ">
              I accept the terms

            </label>
          </div>

          <span className="text-purple-600 underline  ml-6 text-sm">
            Read our T&Cs
          </span>
          <button
            type="submit"
            className="bg-[#C6AFFF] py-3 w-full rounded-lg mt-6 text-white"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default OrganizationAddTaskModal;
